import { render } from "./PostCreator.vue?vue&type=template&id=e7f3650e&scoped=true"
import script from "./PostCreator.vue?vue&type=script&lang=js"
export * from "./PostCreator.vue?vue&type=script&lang=js"

import "./PostCreator.vue?vue&type=style&index=0&id=e7f3650e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7f3650e"]])

export default __exports__